// src/app/redux/reducers/noteDeFraisReducer.js
import {
    FETCH_NOTE_DE_FRAIS_REQUEST,
    FETCH_NOTE_DE_FRAIS_SUCCESS,
    FETCH_NOTE_DE_FRAIS_FAIL,
    FETCH_NOTE_DE_FRAIS_BY_ID_SUCCESS,
    SET_NOTE_DE_FRAIS_LOADING,
    CLEAR_NOTE_DE_FRAIS_ERROR,
    CREATE_NOTE_DE_FRAIS_SUCCESS,
    UPDATE_NOTE_DE_FRAIS_SUCCESS,
    UPDATE_NOTE_DE_FRAIS_FAIL,
    DELETE_NOTE_DE_FRAIS_SUCCESS,
    FETCH_NOTE_DE_FRAIS_ACTIFS_SUCCESS,
} from "../actions/noteDeFraisActions";

const initialState = {
    loading: false,
    error: null,
    notesDeFrais: [],
    currentNoteDeFrais: null,
    notesDeFraisActifs: [],
};

export default function noteDeFraisReducer(state = initialState, action) {
    switch (action.type) {
        case SET_NOTE_DE_FRAIS_LOADING:
            return { ...state, loading: action.payload };

        case CLEAR_NOTE_DE_FRAIS_ERROR:
            return { ...state, error: null };

        case FETCH_NOTE_DE_FRAIS_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_NOTE_DE_FRAIS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                notesDeFrais: action.payload || [],
            };

        case FETCH_NOTE_DE_FRAIS_FAIL:
            return { ...state, loading: false, error: action.payload };

        case FETCH_NOTE_DE_FRAIS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                currentNoteDeFrais: action.payload,
            };

        case CREATE_NOTE_DE_FRAIS_SUCCESS:
            return {
                ...state,
                loading: false,
                notesDeFrais: [action.payload, ...state.notesDeFrais],
            };

        case UPDATE_NOTE_DE_FRAIS_SUCCESS: {
            const updated = action.payload;
            return {
                ...state,
                loading: false,
                notesDeFrais: (state.notesDeFrais || []).map((n) =>
                    n.id === updated.id ? updated : n
                ),
                currentNoteDeFrais: state.currentNoteDeFrais?.id === updated.id
                    ? updated
                    : state.currentNoteDeFrais,
            };
        }

        case UPDATE_NOTE_DE_FRAIS_FAIL:
            return { ...state, loading: false, error: action.payload };

        case DELETE_NOTE_DE_FRAIS_SUCCESS:
            return {
                ...state,
                loading: false,
                notesDeFrais: state.notesDeFrais.filter((n) => n.id !== action.payload),
            };

        case FETCH_NOTE_DE_FRAIS_ACTIFS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                notesDeFraisActifs: action.payload || [],
            };

        default:
            return state;
    }
}